import React from "react"
import MonitorIPsStock from "./MonitorIPsStock"
import MonitorStock from "./MonitorStock"
import MonitorConsumptionReportList from "pages/Monitor/Reports/ConsumptionReport"
import MonitorRealtimeDashboard from "./MonitorRealtimeDashboard"

const MonitorDashboardComponent = ({
  provStock,
  onSubmit,
  onCategoryChange,
  provIpsStock,
  onAdvancedSearchHandler,
  onProviderStockExport,
  onIPsAdvanceSearchHandler,
  onIPStockExport,
  provData,
}) => {
  return (
    <React.Fragment>
      {/* Monitor Charts and Map Section */}
      <MonitorRealtimeDashboard />
      <br />
      <br />

      {/* Monitor Inventory Dashboard Component  */}
      <MonitorStock
        provStock={provStock}
        provData={provData}
        onSubmit={onSubmit}
        onCategoryChange={onCategoryChange}
        onAdvancedSearchHandler={onAdvancedSearchHandler}
        onProviderStockExport={onProviderStockExport}
      />
      <br />
      <br />
      {/* Monitor IPs Inventory Dashboard Component  */}
      <MonitorIPsStock
        provIPsStock={provIpsStock}
        onCategoryChange={onCategoryChange}
        onIPsAdvanceSearchHandler={onIPsAdvanceSearchHandler}
        onIPStockExport={onIPStockExport}
      />

      <br />
      <br />

      {/* Monitor Consumption Report Component on Dashboard  */}
      <MonitorConsumptionReportList from={"Dashboard"} />
    </React.Fragment>
  )
}

export default MonitorDashboardComponent
